import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import CardTitleContainer from '../layout/CardTitleContainer';
import FloatingCard from '../layout/FloatingCard';
import Typography from '@material-ui/core/Typography';
import {
	closeCountrySongsModal,
	closeAddSongToPlaylistModal,
	openAddSongToPlaylistModal
} from '../../state-management/actions/modal-actions';
import {
	addSongToFavoritesList,
	addSongToFavoritesListRequest,
	getCountrySongsRequest,
	removeSongFromFavoritesList,
	removeSongFromFavoritesListRequest,
	selectSongToViewInfo,
	setSelectedCountry
} from '../../state-management/actions/songs-actions';
import '../../style/CountrySongsList.css';
import EmptyCountryDialog from '../misc/EmptyCountryDialog';
import {
	FaExternalLinkAlt
} from 'react-icons/fa';
import {
	CloseButton
} from '../../style/Global';
import SongsList from '../songs/SongsList';
import MediaQuery from 'react-responsive';

class CountrySongsList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			genres: [],
			selectedCountrySongs: [],
			filteredSongsByGenre: [],
			genreSelected: null,
			genreDropdownOpen: false,
			checkBoxesStatus: {},
			sortBy: 'artist',
			playerState: {
				songSelected: {},
				playAutomatically: false,
				firstSongPlay: false
			},
			actionsAllowed: ['addToPlaylist', 'favorites', 'learnMore']
		};
	}

	componentDidUpdate(prevProps) {
		const {
			loadedCountrySongs
		} = this.props;

		// console.log('pre load', loadedCountrySongs);
		// console.log('selectedCountrySongs', selectedCountrySongs);
		if (loadedCountrySongs && prevProps.loadedCountrySongs !== loadedCountrySongs) {
			// console.log('load', loadedCountrySongs);
			// this.loadCountrySongs();
		}
	}

	closeCountrySongsModal = () => {
		const { closeCountrySongsModal, history, setSelectedCountry } = this.props;
		closeCountrySongsModal();
		setSelectedCountry('');
		history.push('/explore');
	}

	getCountrySelectedName = (selectedCountryName) => {
		if (selectedCountryName === 'United States of America') {
			return 'United States';
		}
		if (selectedCountryName === 'United Kingdom of Great Britain and Northern Ireland') {
			return 'United Kingdom';
		}
		else {
			return selectedCountryName;
		}
	}

	render() {
		const {
			actionsAllowed
		} = this.state;
		var {
			countriesWithSongs,
			selectedCountryName: unmodifiedSelectedCountryName,
			selectedCountrySongs
		} = this.props;
		// const { selectedCountrySongs } = this.state;

		const selectedCountryName = this.getCountrySelectedName(unmodifiedSelectedCountryName);
		return (
			<FloatingCard>
				<CardTitleContainer>
					<Typography variant='h4' gutterBottom>
						{selectedCountryName}
					</Typography>
					<div className='card-title-container-right'>
						<MediaQuery
							maxDeviceWidth={768}
						>
							<Typography variant='subtitle1' gutterBottom
								style={{
									marginTop:'5px'
								}}
							
							>							
							<Button
									href={`https://en.wikipedia.org/wiki/Music_of_${selectedCountryName}`}
									target="_blank"
									rel="noopener noreferrer"
									className="country-songs-button primary-button"
								>
									Learn more...<FaExternalLinkAlt />
								</Button>
							</Typography>
						</MediaQuery>
						<MediaQuery
							minDeviceWidth={769}
						>
							<Typography variant='subtitle1' gutterBottom>
								Learn more about the music of&nbsp;
							<Button
									href={`https://en.wikipedia.org/wiki/Music_of_${selectedCountryName}`}
									target="_blank"
									rel="noopener noreferrer"
									className="country-songs-button primary-button"
								>
									{selectedCountryName}<FaExternalLinkAlt />
								</Button>
							</Typography>
						</MediaQuery>

						<CloseButton onClick={this.closeCountrySongsModal} />
					</div>
				</CardTitleContainer>
				{
					countriesWithSongs.includes(unmodifiedSelectedCountryName) ?
						<SongsList
							actionsAllowed={actionsAllowed}
							songsList={selectedCountrySongs}
							requestIdentifierForeign={selectedCountryName}
						/>
						:
						<EmptyCountryDialog />
				}

			</FloatingCard>
		);
	}
}

const mapStateToProps = state => {
	const { songsReducers } = state;
	const {
		countriesWithSongs,
		selectedCountryName,
		selectedCountrySongs
	} = songsReducers;

	console.log('selectedCountryName',selectedCountryName)
	return {
		countriesWithSongs,
		selectedCountryName,
		selectedCountrySongs
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		addSongToFavoritesList: (song) => dispatch(addSongToFavoritesList(song)),
		addSongToFavoritesListRequest: (favoriteSongsList) => dispatch(addSongToFavoritesListRequest(favoriteSongsList)),		
		closeCountrySongsModal: () => dispatch(closeCountrySongsModal()),
		closeAddSongToPlaylistModal: () => dispatch(closeAddSongToPlaylistModal()),
		getCountrySongsRequest: countrySongs => dispatch(getCountrySongsRequest(countrySongs)),
		openAddSongToPlaylistModal: () => dispatch(openAddSongToPlaylistModal()),
		removeSongFromFavoritesList: (song) => dispatch(removeSongFromFavoritesList(song)),
		removeSongFromFavoritesListRequest: (song) => dispatch(removeSongFromFavoritesListRequest(song)),
		selectSongToViewInfo: (song) => dispatch(selectSongToViewInfo(song)),
		setSelectedCountry: (selectedCountryName) => dispatch(setSelectedCountry(selectedCountryName))
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CountrySongsList));